export const SEND_LIMITS = Object.freeze({
    hardRolling24h: 20,
    plannerRolling24h: 18,
    hourly: 4,
    workerBatch: 3,
    cancelBufferMinutes: 0,
    teamCooldownDays: 14,
});
export function sendBlockReasons(x) {
    const reasons = [];
    if (!x.verifiedEmail)
        reasons.push('Usable recipient email required');
    if (x.doNotContact)
        reasons.push('Do not contact');
    if (!x.hasTimezone)
        reasons.push('Known recipient timezone required');
    if (!x.approvalHashMatches)
        reasons.push('Approved content changed');
    if (x.duplicate)
        reasons.push('Possible duplicate outreach');
    if (x.teamCoolingActive)
        reasons.push('Same-team cooling period active');
    if (x.sentRolling24h >= SEND_LIMITS.hardRolling24h)
        reasons.push('Rolling 24h hard limit reached');
    if (x.sentRollingHour >= SEND_LIMITS.hourly)
        reasons.push('Hourly send limit reached');
    if (x.automationMode !== 'LIVE')
        reasons.push(`Automation is ${x.automationMode}`);
    return reasons;
}
export function canSend(x) {
    return sendBlockReasons(x).length === 0;
}
